import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import { Events } from 'constants';

import RestaurantMenuStore from 'stores/RestaurantMenuStore';
import OrderSettingsStore from 'stores/OrderSettingsStore';

import { RouteAction, RestaurantMenuAction } from 'actions';
import RoutingEnum from 'constants/RoutingEnum';

// -- utils
import { StringUtils, ViewUtils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';

// -- entities
import { RestaurantMenu, Product } from 'PMT/entities/menu';

// -- views
import AbstractRestaurantMenuComponent from '../components/AbstractRestaurantMenuComponent';
import RoundButton from 'components/RoundButton';
import SearchBox from 'PMT/components/SearchBox';
import ProductRow from './components/ProductRow';

export default class ProductsListPage extends AbstractRestaurantMenuComponent {

  static defaultProps = {
    hideDeactivatedProducts: true
  };

  static propTypes = {
    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired
  };

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.hideLoading);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.hideLoading);
  }

  // -- events

  onAddProductClicked = () => {
    RouteAction.redirectTo(RoutingEnum.RESTAURANT_MENU_PRODUCT_NEW);
  };

  //
  //
  //

  onProductChange = (product: Product) => {
    const restaurantMenu: RestaurantMenu = this.restaurantMenu.copy();

    restaurantMenu.updateProduct(product);
    this.setState({
      restaurantMenu
    });
  };

  // -- search events

  onSearchInput = (search: string) => {
    this.setState({
      search
    });
  };

  // -- utils

  get search() {
    return this.state.search;
  }

  // -- renderers

  renderAddProductBtn() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (null);
    }

    if (OrderSettingsStore.getOrderSettings().menuManagedByPos) {
      return (null);
    }

    return (
      <RoundButton
        onClick={this.onAddProductClicked}
        text={I18n.tr('menu.product.list.create_product')}
      />
    );
  }

  renderSearchBar() {
    return (
      <div className="row">
        <div className="top-buffer-30 col-sm-12 col-md-6 col-md-offset-3">
          <SearchBox
            search={this.search}
            onSearchInput={this.onSearchInput}
          />
        </div>
      </div>
    );
  }

  renderTheadContent() {
    return (
      <tr>
        <th className="hidden-xs hidden-sm col-md-1 text-left">

        </th>
        <th className="col-xs-10 col-sm-8">
          {I18n.tr('menu.product.list.table.header.name')}
        </th>
        <th className="hidden-xs col-sm-3 col-md-2 text-center">
          {I18n.tr('menu.product.list.table.header.prices')}
        </th>
        <th className="col-xs-1 col-sm-1 text-center">
          {I18n.tr('menu.product.list.table.header.availibility')}
        </th>
      </tr>
    );
  }

  renderList() {
    const productsListView = [];

    const sortedProductsList = _.sortBy(this.restaurantMenu.products, ['desc'],
      (product: Product): number => {
        // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
        return StringUtils.toAlphaNum(product.name).toLowerCase();
      }
    );

    _.each(sortedProductsList, (product: Product) => {

      if (_.isEmpty(this.state.search)
      || StringUtils.searchStringOn(this.state.search, product.name)) {
        productsListView.push(
          <ProductRow
            product={product}
            key={product.id}
            onChange={this.onProductChange}
            disableStockModification={this.props.disableStockModification}
            currencyCode={this.props.currencyCode}
          />
        );
      }
    });

    return (
      <div className="top-buffer-30 table_container">

        <table className="table table-responsive">
          <thead>
            {this.renderTheadContent()}
          </thead>
          <tbody>
            {productsListView}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div className="products_list top-buffer-30">
        {this.renderAddProductBtn()}

        {!_.isEmpty(this.restaurantMenu.products) &&
          this.renderSearchBar()
        }
        {!_.isEmpty(this.restaurantMenu.products) &&
          this.renderList()
        }

        {(
          SecurityContext.restaurantMenu.canEdit() ||
          SecurityContext.restaurantMenu.canEditAvailabilityProducts()
        ) &&
          this.renderFixedButtons()
        }
        {this.renderLoading()}
      </div>
    );
  }

}
